<template>
  <div>


<vx-card :title="$t('Filters')" class="mb-8" collapse-action>
  <div class="vx-row mb-4">
    <div class="vx-col md:w-full w-full">
      <label class="text-sm opacity-75">{{ $t("QuickSearch") }} ({{ $t("NameOrCode") }})</label>
      <vs-input 
        icon-pack="feather" 
        icon="icon-search" 
        :placeholder="$t('SearchPlaceholder')" 
        v-model="keySearch" 
        class="w-full mt-2" 
      />
      <small v-if="keySearch.length > 0 && keySearch.length < 3" class="text-warning ml-2">
        {{ $t("TypeMoreToSearch") }}
      </small>
    </div>
  </div>

  <vs-divider>{{ $t("OrAdvancedFilters") }}</vs-divider>

  <div class="vx-row">
    <div class="vx-col md:w-1/4 w-full mb-4">
      <label class="text-sm opacity-75">{{ $t("TokenPriceFrom") }}</label>
      <vs-input type="number" class="mt-2 w-full" v-model="filters.MinTokenPrice" />
    </div>
    <div class="vx-col md:w-1/4 w-full mb-4">
      <label class="text-sm opacity-75">{{ $t("TokenPriceTo") }}</label>
      <vs-input type="number" class="mt-2 w-full" v-model="filters.MaxTokenPrice" />
    </div>
    <div class="vx-col md:w-1/4 w-full mb-4">
      <label class="text-sm opacity-75">{{ $t("ExpectedReturnFrom") }}</label>
      <vs-input type="number" class="mt-2 w-full" v-model="filters.MinExpectedReturn" />
    </div>
    <div class="vx-col md:w-1/4 w-full mb-4">
      <label class="text-sm opacity-75">{{ $t("ExpectedReturnTo") }}</label>
      <vs-input type="number" class="mt-2 w-full" v-model="filters.MaxExpectedReturn" />
    </div>
  </div>
  <!-- كارت مستقل لإعدادات الضريبة -->
<vx-card :title="$t('TaxSettings') || 'إعدادات الضريبة'" class="mb-8">
  <div class="vx-row items-end">
    <div class="vx-col md:w-1/3 w-full mb-2">
      <label class="text-sm font-medium">{{ $t("VatPercentage") || "نسبة ضريبة القيمة المضافة (%)" }}</label>
      <vs-input 
        type="number" 
        class="mt-2 w-full" 
        v-model.number="vatPercentage"
        icon-pack="feather"
        icon="icon-percent"
        icon-after="true"
        min="0"
        max="100"
      />
    </div>

    <div class="vx-col md:w-1/3 w-full mb-2">
     <vs-button 
  color="success" 
  icon-pack="feather" 
  icon="icon-save" 
  @click="saveTaxRate"
  :disabled="isTaxSaving"
>
  {{ $t("SaveTaxRate") || "حفظ نسبة الضريبة" }}
</vs-button>
    </div>
  </div>
</vx-card>

  <div class="vx-row mt-4">
    <div class="vx-col flex flex-wrap gap-2">
      <vs-button color="primary" @click="applyFilters">
        {{ $t("ApplyFilters") }}
      </vs-button>
      
      <vs-button color="danger" type="border" @click="resetAll">
        {{ $t("ResetSearch") }}
      </vs-button>
    </div>
  </div>
</vx-card>

    <div id="data-list-list-view" class="data-list-container">
      <vs-table
        ref="table"
        id="Scroll"
        pagination
        :max-items="itemsPerPage"
        search
        :page="currentPage"
        :data="Opportunities"
      >
        <div
          slot="header"
          class="flex flex-wrap-reverse items-center flex-grow justify-between"
        >
          <div class="vx-row" v-if="userInfo.userType!='Member'">
            <div class="vx-col">
              <vs-button
                type="border"
                class="ml-5"
                icon-pack="feather"
                icon="icon-plus"
                @click="AddOrEditData"
                >{{ $t("AddNewOpportunity") }}</vs-button
              >
            </div>
            <!-- <div class="vx-col">
              <vs-button
                type="border"
                class="ml-5"
                icon-pack="feather"
                icon="icon-plus"
                @click="AddOrEditData"
                >{{ $t("ExportCSV") }}</vs-button
              >
            </div> -->
          </div>

          <vs-dropdown vs-trigger-click class="cursor-pointer mb-4 mr-4">
            <div
              class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium"
            >
              <span class="mr-2"
                >{{ currentPage * itemsPerPage - (itemsPerPage - 1) }} -
                {{
                  Opportunities.length - currentPage * itemsPerPage > 0
                    ? currentPage * itemsPerPage
                    : Opportunities.length
                }}
                of {{ Opportunities.length }}</span
              >
              <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
            </div>

            <vs-dropdown-menu>
              <vs-dropdown-item @click="itemsPerPage = 4">
                <span>4</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="itemsPerPage = 10">
                <span>10</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="itemsPerPage = 15">
                <span>15</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="itemsPerPage = 20">
                <span>20</span>
              </vs-dropdown-item>
            </vs-dropdown-menu>
          </vs-dropdown>
        </div>

        <template slot="thead">
          <vs-th sort-key="IdentityCard">{{ $t("Code") }}</vs-th>
          <vs-th sort-key="Name">{{ $t("Property") }}</vs-th>
          <vs-th sort-key="Country">{{ $t("Tokens") }}</vs-th>
          <vs-th sort-key="Email">{{ $t("TokenPrice") }}</vs-th>
          <vs-th sort-key="Email">{{ $t("Sold") }}</vs-th>
          <vs-th sort-key="Email">{{ $t("Avilable") }}</vs-th>
          <vs-th sort-key="Email">{{ $t("Status") }}</vs-th>

          <vs-th> {{ "Actions" }}</vs-th>
        </template>

        <template slot-scope="{ data }">
          <tbody>
            <tr
              :data="tr"
              :key="indextr"
              v-for="(tr, indextr) in data"
              @click="AddOrEditData(tr)"
            >
              <vs-td>
                <p class="product-name font-medium truncate">{{tr.OpportunityCode}}</p>
              </vs-td>
              <vs-td>
               <p class="product-name font-medium truncate">
                  {{ currentLocale === 'ar' ? tr.OpportunityNameAr : tr.OpportunityNameEn }}
                </p>
              </vs-td>
              <vs-td>
                <p class="product-name font-medium truncate">{{tr.TotalTokens}}</p>
              </vs-td>
              <vs-td>
                <p class="product-name font-medium truncate">{{tr.TokenPrice}}</p>
              </vs-td>
               <vs-td>
                <p class="product-name font-medium truncate">{{tr.SoldTokensCount}}</p>
              </vs-td>
               <vs-td>
                <p class="product-name font-medium truncate">{{tr.AvailableTokensCount}}</p>
              </vs-td>
               <vs-td>
                <p>
                  {{ statusMap[tr.OpportunityStatusId] || tr.OpportunityStatusId }}
                </p>
              </vs-td>

              <vs-td class="whitespace-no-wrap">
                <div class="icon-container">
                  <div >
                    <vx-tooltip text="Show Details" position="top">
                 <router-link
                  :to="{name: 'AddOrEditOpportunities',params: { ID: tr.ID },}">
                  <feather-icon
                    icon="EditIcon"
                    @click = "AddOrEditData(tr)"
                    svgClasses="w-5 h-5 hover:text-primary stroke-current"
                  />
                </router-link>
                </vx-tooltip>
                  </div>

                <div >
                  <vx-tooltip color="red" text="Delete Member" position="top">
                <feather-icon
                  icon="TrashIcon"
                  svgClasses="w-10 h-5 hover:text-primary stroke-current"

                  @click.stop="openConfirm(tr)"
                />
              </vx-tooltip>
                </div>
                </div>
              </vs-td>


            </tr>
          </tbody>
        </template>
      </vs-table>
    </div>
  </div>
</template>

<script>
import Datepicker from "vuejs-datepicker";
import vSelect from "vue-select";
import { domain } from "@/gloabelConstant.js";
import moduleOpportunities from "@/store/Opportunities/moduleOpportunities.js";
import moduleOpportunityStatus from "@/store/OpportunityStatus/moduleOpportunityStatus.js";


export default {
  components:
   {
     Datepicker ,
     vSelect,
  },
 watch: {
    // مراقب لمتغير البحث
    keySearch(val) {

      clearTimeout(this.searchTimer);


      if (val.length === 0) {
        this.$store.dispatch("OpportunitiesList/fetchDataListItems");
        return;
      }


      if (val.length >= 3) {
        this.searchTimer = setTimeout(() => {
          this.executeSearch();
        }, 500); 
      }
    }
  },
  data() {
    return {
      itemsPerPage: 10,
      isMounted: false,
     keySearch: "", 
   
      isTaxSaving: false,
    
    // كائن للفلاتر المتقدمة (OpportunityFilterRequest)
    filters: {
      MinTokenPrice: null,
      MaxTokenPrice: null,
      MinExpectedReturn: null,
      MaxExpectedReturn: null,
      // أضف أي حقول أخرى يتوقعها الـ FilterByDistance إذا لزم الأمر
    },

      baseURL: domain,
      userInfo: {},
      //countries: [],
    };
  },
  computed: {
    currentLocale() {
    return this.$i18n.locale;
  },
    currentPage() {
  
      if (this.isMounted) {
        return this.$refs.table.currentx;
      }
      return 0;
    },
    Opportunities() {
   
       return this.$store.state.OpportunitiesList.Opportunities;
   },
     statuses() {
      return this.$store.state.OpportunityStatusList.OpportunityStatusList;
    },
    vatPercentage() {
      
      return this.$store.state.OpportunitiesList.vatPercentage;
    },

    statusMap() {
    const map = {};
    const labelKey = this.currentLocale === 'ar' ? 'OpportunityStatusNameAr' : 'OpportunityStatusNameEn';
    
    this.statuses.forEach(s => {
      map[s.id] = s[labelKey];
    });
    return map;
  },
  
  },
  methods: {
executeSearch() {

      this.$store.dispatch("OpportunitiesList/searchOpportunities", this.keySearch.trim())
        .then(() => {

          this.$refs.table.currentx = 1;
        })
        .catch((err) => {
          console.error("Search Error:", err);
        });
    },
// getTaxRate() {
//       this.$store.dispatch('OpportunitiesList/fetchTaxRate')
//         .then(response => {
//           if (response.data && response.data.vatPercentage !== undefined) {
//             this.vatPercentage = response.data.vatPercentage;
//           }
//         })
//         .catch(error => {
//           console.error("Error fetching tax rate:", error);
//         });
//     },

    saveTaxRate() {
      if (this.vatPercentage === null || this.vatPercentage < 0) {
        this.$vs.notify({
          title: "تنبيه",
          text: "برجاء إدخال نسبة ضريبة صحيحة",
          color: "warning"
        });
        return;
      }

      this.isTaxSaving = true;

      this.$store.dispatch('OpportunitiesList/updateTaxRate', this.vatPercentage)
        .then(response => {
          this.isTaxSaving = false;
          this.$vs.loading.close();

          this.$vs.notify({
            title: "تم بنجاح",
            text: response.data.message || "تم حفظ نسبة الضريبة بنجاح",
            color: "success",
            iconPack: "feather",
            icon: "icon-check"
          });
        })
        .catch(error => {
          this.isTaxSaving = false;
          this.$vs.loading.close();

          let msg = "حدث خطأ أثناء حفظ الضريبة";
          if (error.response && error.response.data) {
            msg = typeof error.response.data === 'string' ? error.response.data : error.response.data.message;
          }

          this.$vs.notify({
            title: "خطأ",
            text: msg,
            color: "danger"
          });
        });
    },
  // للفلاتر المتقدمة (API Filter)
  applyFilters() {
    this.$vs.loading();
    this.$store.dispatch("OpportunitiesList/filterOpportunities", this.filters)
      .then(() => { this.$vs.loading.close(); })
      .catch(() => { this.$vs.loading.close(); });
  },

  resetAll() {
    this.keySearch = "";
    this.filters = {
      MinTokenPrice: null,
      MaxTokenPrice: null,
      MinExpectedReturn: null,
      MaxExpectedReturn: null,
    };
    this.$store.dispatch("OpportunitiesList/fetchDataListItems");
  },
    cancelSearch(){
    
      this.search = {
        IdentityCard: null,
        Name: null,
        JobTitle: null,
        PhoneNumber: null,
        CountryID: null,
        Email: null,
        PageNumber: 0,
        PageSize: 20,
      };

      this.$store.dispatch("OpportunitiesList/fetchDataListItems");
    },
    AddOrEditData(data) {

      if (data.Id == undefined) {
          data.Id = 0;
      }

    
      this.$router.push(`/Opportunities/AddOrEditOpportunities/${data.Id}`);
    },


    acceptApprove() {
      this.ApproveMember(this.rowDataForDelete);
      this.$vs.notify({
        color: "success",
        title: "Approve Member",
        text: "Member Approved Successfully",
      });

    },


    openConfirm(data) {
    
      this.rowDataForDelete = data;
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: `Confirm`,
        text: "Confirm Delete",
        accept: this.acceptAlert,
        acceptText: "Delete",
        cancelText: "Cancel",
      });
    },
    acceptAlert() {
      this.deleteData(this.rowDataForDelete);


      this.handleSearch(this.search);
    },
    deleteData(data) {
      this.$store.dispatch("OpportunitiesList/removeItem", data) .then((response) => {
        
      if (response && response.message && response.message.includes("Cannot delete Member")) {
        
        this.$vs.dialog({
          type: "alert",
          color: "danger",
          title: "Cannot Delete",
          text: response.message,
          acceptText: "OK",
        });
      } else {
      
        this.$store.dispatch("OpportunitiesList/fetchDataListItems");
        this.$vs.notify({
        color: "success",
        title: "Deleted record",
        text: this.$t("DeletedSuccessfully"),
      });
      }
    })
    .catch((err) => {
        console.error(err);
        let errorMessage = "An error occurred while deleting the Member.";
        
        if (err.response && err.response.data && err.response.data.message) {
          errorMessage = err.response.data.message;
        }
        
        this.$vs.dialog({
          type: "alert",
          color: "danger",
          title: "Error",
          text: errorMessage,
          acceptText: "OK",
        });
        
        this.$store.dispatch("OpportunitiesList/fetchDataListItems");
      });
    },
  },
  created() {
   
    if (!moduleOpportunities.isRegistered) {
      this.$store.registerModule("OpportunitiesList", moduleOpportunities);
      moduleOpportunities.isRegistered = true;
    }
  
    this.$store.dispatch("OpportunitiesList/fetchDataListItems");

    this.userInfo = JSON.parse(localStorage.getItem("userInfo"));


  if (!moduleOpportunityStatus.isRegistered) {
      this.$store.registerModule("OpportunityStatusList", moduleOpportunityStatus);
      moduleOpportunityStatus.isRegistered = true;
    } 

     
    this.$store.dispatch("OpportunityStatusList/fetchDataListItems");
     this.$store.dispatch('OpportunitiesList/fetchTaxRate')
  },
  mounted() {
    this.isMounted = true;
  },
};
</script>

<style lang="scss">

 .icon-container{
    display: flex;
  }
#data-list-list-view small {
  color: rgb(255, 115, 0);
  text-decoration: underline rgb(255, 115, 0);
}

.vxCard:after {
  content: "";
  position: absolute;
  top: 0px;
  left: 0%;
  margin-left: 10%;
  z-index: 500000;
  width: 25%;
  height: 20%;
  border-top: 3px solid rgb(255, 115, 0) !important;
  border-bottom: 0 none rgba(255, 0, 0, 0.9) !important;
  border-right: 0 none rgba(255, 0, 0, 0.9) !important;
  border-left: 0 none rgba(0, 0, 0, 0.9) !important;
}
#data-list-list-view {
  .vs-con-table {
    .product-name {
      max-width: 23rem;
    }

    .vs-table--header {
      display: flex;
      flex-wrap: wrap-reverse;
      margin-left: 1.5rem;
      margin-right: 1.5rem;
      > span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search {
        padding-top: 0;

        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;

          & + i {
            left: 1rem;
          }

          &:focus + i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table {
      border-collapse: separate;
      border-spacing: 0 1.3rem;
      padding: 0 1rem;

      tr {
        box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.05);
        td {
          padding: 20px;
          &:first-child {
            border-top-left-radius: 0.5rem;
            border-bottom-left-radius: 0.5rem;
          }
          &:last-child {
            border-top-right-radius: 0.5rem;
            border-bottom-right-radius: 0.5rem;
          }
        }
        td.td-check {
          padding: 20px !important;
        }
      }
    }

    .vs-table--thead {
      th {
        padding-top: 0;
        padding-bottom: 0;

        .vs-table-text {
          text-transform: uppercase;
          font-weight: 600;
        }
      }
      th.td-check {
        padding: 0 15px !important;
      }
      tr {
        background: none;
        box-shadow: none;
      }
    }

    .vs-table--pagination {
      justify-content: center;
    }

    .btn{
      margin-top: 5%;
    }
  }
}
</style>
